// @owners { team: patients }
import { DateRestrictionReasonMap } from '@alto/scriptdash/alto/scheduling/types/v1/date_restriction_reason';
import { type AvailableDate } from '~shared/types/clients';

/**
 * Restore the Progyny refill-too-soon reason hidden by the backend for older app versions.
 * This enables the correct “Next refill” message and prevents incorrect insurance routing.
 */
export function unmaskProgynyReason(date: AvailableDate): AvailableDate;
export function unmaskProgynyReason(date: AvailableDate | undefined): AvailableDate | undefined;
export function unmaskProgynyReason(date: AvailableDate | undefined): AvailableDate | undefined {
  if (!date || date.internal_reason !== DateRestrictionReasonMap.PROGYNY_REFILL_TOO_SOON) {
    return date;
  }

  return { ...date, reason: DateRestrictionReasonMap.PROGYNY_REFILL_TOO_SOON };
}
